import { Component, inject, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";

@Component({
  selector: "stat-begreper",
  templateUrl: "./begreper.component.html",
  standalone: true,
})
export class BegreperComponent implements OnInit {
  titleService = inject(Title);

  begrepskode = 1;

  onBegrepChange(entry): void {
    this.begrepskode = entry;
  }

  ngOnInit() {
    this.titleService.setTitle("Statistikk - Begrepsforklaringer - Husbanken");
  }
}
